import React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Colors } from '../../themes/Colors';
import ButtonGradient from '../button-gradient';
import TextBase from '../text';
import ErrorIcon from '../../assets/image/svg/error.svg';
import WarningIcon from '../../assets/image/svg/warning.svg';
import CheckboxIcon from '../../assets/image/svg/checkbox-white.svg';
import { SVGImageComponentReact } from '../../themes/Images';
import LocalStorage from '../../defined/localStorage';
import { useSelector } from 'react-redux';

const brand = JSON.parse(LocalStorage.getItem('branding'));

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 'calc(var(--sp-xxs)*2)',
    padding: 'calc(var(--sp-md2)*3.867924) 0px calc(var(--sp-md2)*1.886792)',
  },
}));

export const ConfirmModal = ({
  visible = false,
  isLoading = false,
  handleOk = () => {},
  handleCancel = () => {},
  status = 'danger' || 'warning' || 'success',
  cancelBtnText = 'CANCEL',
  okBtnText = 'OK',
  children,
  showIcon = false,
  width = 'calc(var(--fs-hero)*12.9716981)',
  hideIcon = false,
  showButtons = true,
  isLoadingLeft = false,
  message = '',
}) => {
  const whiteLabel = useSelector((state) => state.User?.branding);

  const iconSrc =
    status === 'danger'
      ? ErrorIcon
      : status === 'warning'
      ? WarningIcon
      : CheckboxIcon;

  return (
    <StyledDialog
      open={visible}
      onClose={handleCancel}
      maxWidth={false}
      PaperProps={{
        style: {
          width,
        },
      }}
    >
      <IconButton
        onClick={handleCancel}
        sx={{
          position: 'absolute',
          right: 'calc(var(--sp-md2)*1.132075)',
          top: 'calc(var(--sp-md2)*1.132075)',
          
        }}
      >
        <CloseIcon sx={{fontSize: 'calc(var(--fs-sm)*2)'}} />
      </IconButton>

      {/* Icon */}
      {!hideIcon && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 'calc(var(--sp-md2)*1.886792)',
            padding:'calc(var(--sp-md2)*1.886792)'
          }}
        >
          <img src={iconSrc} style={{ height: 'calc(var(--fs-hero)*2.35849)', width: 'calc(var(--fs-hero)*2.35849)'}} />
        </div>
      )}

      <DialogContent sx={{ padding: 'calc(var(--sp-md2)*2.105263) calc(var(--sp-md2)*2.5263157) calc(var(--sp-md2)*1.132075)' }}>
        {message?.length ? (
          <TextBase
            size={'var(--fs-body)'}
            style={{
              textAlign: 'center',
              color: status === 'danger' ? Colors.red : Colors.black,
              marginBottom: 'calc(var(--sp-md2)*1.886792)',
            }}
          >
            {message}
          </TextBase>
        ) : (
          children
        )}

        {showButtons && (
        <div style={{ display: 'flex' }}>
          <ButtonGradient
            onClick={handleCancel}
            textStyle={{
              fontSize: 'var(--fs-body)',
              lineHeight: 'var(--sp-lg*1.179245)',
              margin: 0,
              color: Colors.grey
            }}
            title={cancelBtnText}
            iconSize={'calc(var(--sp-lg)*1.132075)'}
            backgroundColor={Colors.white}
            style={{
              marginRight: 'var(--sp-md2)',
              // minWidth: '300px',
              padding: '0px var(--sp-md2)',
              border: `1px solid ${Colors.grey}`,
              color: Colors.grey,
              textTransform: 'uppercase'
            }}
            loading={isLoadingLeft}
          />
          <ButtonGradient
            onClick={handleOk}
            textStyle={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--sp-md2*1.886792)', margin: 0 }}
            iconStyle={{}}
            icon={showIcon ? SVGImageComponentReact.LockIcon : null}
            title={okBtnText}
            iconSize={'calc(var(--fs-xl)*1.132075)'}
            backgroundColor={
              status === 'danger'
                ? Colors.red
                : status === 'warning'
                ? (whiteLabel?.web_button_color||brand?.web_button_color||Colors.primary)
                : status === 'success'
                ? Colors.success
                : Colors.black
            }
            style={{
              marginLeft: 'var(--sp-md2)',
              textTransform: 'uppercase'
              // minWidth: '220px',
              // padding: '0px 10px'
            }}
            loading={isLoading}
          />
        </div>
      )}
      </DialogContent>
    </StyledDialog>
  );
};
